// @ts-ignore
/* eslint-disable */
import newRelicAgentUrl from "../assets/scripts/new-relic-agent.js?url";
import { reportClientCrashToNimbble } from "./nimbble-alert";

declare global {
  interface Window {
    NREUM: {
      init?: Record<string, unknown>;
      loader_config?: Record<string, unknown>;
      info?: Record<string, unknown>;
    };
    newrelic?: {
      noticeError: (error: Error, customAttributes?: Record<string, unknown>) => void;
    };
  }
}

declare const __ENABLE_NEW_RELIC__: boolean;
declare const __NEW_RELIC_CONFIG__: {
  accountId: string;
  licenseKey: string;
  applicationId: string;
  trustKey: string;
};

const initNewRelic = (): void => {
  if (!__ENABLE_NEW_RELIC__) {
    console.log("[New Relic] Disabled - REACT_APP_ENABLE_NEW_RELIC is not set to 'true'");
    return;
  }

  const config = __NEW_RELIC_CONFIG__;

  if (!config.licenseKey || !config.applicationId) {
    console.warn("[New Relic] Missing required configuration");
    return;
  }

  window.NREUM = window.NREUM || {};
  window.NREUM.init = {
    distributed_tracing: { enabled: true },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ["bam.eu01.nr-data.net"] },
  };

  window.NREUM.loader_config = {
    accountID: config.accountId,
    trustKey: config.trustKey,
    agentID: config.applicationId,
    licenseKey: config.licenseKey,
    applicationID: config.applicationId,
  };

  window.NREUM.info = {
    beacon: "bam.eu01.nr-data.net",
    errorBeacon: "bam.eu01.nr-data.net",
    licenseKey: config.licenseKey,
    applicationID: config.applicationId,
    sa: 1,
  };

  const script = document.createElement("script");
  script.src = newRelicAgentUrl;
  script.defer = true;
  document.head.appendChild(script);

  setupGlobalErrorHandlers();

  console.log("[New Relic] Initialized!");
};

const setupGlobalErrorHandlers = (): void => {
  window.addEventListener("error", (event) => {
    const error = event.error || new Error(event.message);

    if (window.newrelic) {
      window.newrelic.noticeError(error, {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        type: "uncaughtError",
      });
    }

    reportClientCrashToNimbble({ errorType: "uncaught", error });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const error =
      event.reason instanceof Error
        ? event.reason
        : new Error(String(event.reason));

    if (window.newrelic) {
      window.newrelic.noticeError(error, { type: "unhandledRejection" });
    }

    reportClientCrashToNimbble({ errorType: "unhandledRejection", error });
  });
};

export default initNewRelic;
